export default __webpack_public_path__ + "assets/images/thanks-modal-bg-dc2865b8.png";